






































import { Component, Mixins, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import UserApi from '@/api/identity/user/index'
import RoleApi from '@/api/identity/role/index'
@Component({
  components: {},
})
export default class AddNewMember extends AbpBase {
  id: string | string[] = ''
  roles: any[] = []
  formValidate: any = {
    userName: null,
    email: null,
    name: null,
    phoneNumber: null,
    roleNames: [],
  }
  ruleValidate: any = {
    userName: [
      {
        required: true,
        message: '请输入用户名',
        trigger: 'blur',
      },
    ],
    password: [
      {
        required: true,
        message: '请输入密码',
        trigger: 'blur',
      },
    ],
    email: [
      {
        required: true,
        message: '请输入邮箱地址',
        trigger: 'blur',
      },
      { type: 'email', message: '邮箱格式错误', trigger: 'blur' },
    ],
    name: [
      {
        required: true,
        message: '请输入姓名',
        trigger: 'blur',
      },
    ],
    phoneNumber: [
      {
        required: true,
        message: '请输入手机号码',
        trigger: 'blur',
      },
    ],
    roleNames: [{ required: true, type: 'array', min: 1, message: '请至少选择一项', trigger: 'change' }],
  }

  mounted() {
    this.loadRole()
  }
  loadRole() {
    RoleApi.getAllRoles().then((res) => {
      this.roles = res.data.items.filter((x) => x.id !== 'd5218e61-2eee-36f6-9c51-39f4760aa51b')
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.loadUserInfo()
      }
    })
  }
  loadUserInfo() {
    UserApi.getUser(this.id)
      .then((res) => {
        this.formValidate = res.data
      })
      .then(() => {
        UserApi.getRoles(this.id).then((res) => {
          this.$set(this.formValidate, 'roleNames', res.data.items.map((x) => x.name))
          this.formValidate.password = 'test'
        })
      })
  }
  submit() {
    let vm = this
    let form: any = vm.$refs.formValidate
    form.validate((valid) => {
      if (valid) {
        if (this.id) {
          //update
          this.formValidate.password = ''
          UserApi.putUser(this.id, this.formValidate).then((res) => {
            this.$Notice.success({
              desc: '修改成功',
            })
            this.$router.push({
              name: 'membermanagement',
            })
          })
        } else {
          //add
          UserApi.postUser(this.formValidate).then((res) => {
            this.$Notice.success({
              desc: '保存成功',
            })
            this.$router.push({
              name: 'membermanagement',
            })
          })
        }
      }
    })
  }
}
